export default __webpack_public_path__ + "static/media/2021-03_Gdesi-io-website.063819fb.jpg";